<script setup lang="ts">
import MarcusLogo from '~/components/MarcusLogo.vue'

defineProps<{
  jurisdiction?: string | null
  jurisdictionTitle?: string
  appEnv?: string | null
}>()
</script>

<template>
  <span class="inline-flex items-center gap-1.5">
    <MarcusLogo class="h-5" />
    <span
      v-if="jurisdiction"
      class="shrink-0 text-[8px] font-bold uppercase tracking-wide text-sidebar-muted leading-none"
      :title="jurisdictionTitle"
    >{{ jurisdiction }}</span>
    <span
      v-if="appEnv && appEnv !== 'production' && appEnv !== 'prod'"
      data-env-badge
      class="shrink-0 self-center rounded border border-sidebar-border px-1 py-px text-[8px] font-bold uppercase tracking-wide leading-none text-sidebar-icon"
      :title="`Environment: ${appEnv}`"
    >{{ appEnv }}</span>
  </span>
</template>
